import React from 'react';
import TableSortNoneIcon from '../../../../component/icons/table-sort-none';
import TableSortDownIcon from '../../../../component/icons/table-sort-down';
import TableSortUpIcon from '../../../../component/icons/table-sort-up';

const SortIcon = React.memo(({ field, sortFields = [], onSort, Style, disabled = false }) => {
  const currentSort = sortFields.find(f => f.field === field)?.order;

  const sortClass = [
    Style.table_sort,
    disabled ? Style.disabledSort : '',
    currentSort === 'asc' ? Style.sortAsc : '',
    currentSort === 'desc' ? Style.sortDesc : '',
  ].join(' ');

  const icon =
    currentSort === 'asc' ? <TableSortUpIcon /> :
      currentSort === 'desc' ? <TableSortDownIcon /> :
        <TableSortNoneIcon />;

  const handleClick = () => {
    if (!disabled && typeof onSort === 'function') {
      onSort(field);
    }
  };

  return (
    <span onClick={handleClick} className={sortClass}>
      {icon}
    </span>
  );
});

export default SortIcon;
